import { render, staticRenderFns } from "./LastNgSubmissionInfo.vue?vue&type=template&id=fe635360&scoped=true&"
import script from "./LastNgSubmissionInfo.vue?vue&type=script&lang=js&"
export * from "./LastNgSubmissionInfo.vue?vue&type=script&lang=js&"
import style0 from "./LastNgSubmissionInfo.vue?vue&type=style&index=0&id=fe635360&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe635360",
  null
  
)

export default component.exports